import { useMutation } from "@tanstack/react-query";
import { MEDAL_URL } from "../util/constants";
import useApi from "./useApi";
import Medal from "../interfaces/medal";

const useAdminCreateMedal = (token: string) => {
    const { register } = useApi<Medal>(`${MEDAL_URL}/${token}`);

    return useMutation({
        mutationFn: (medal: Medal) => register(medal)
    })
}

export default useAdminCreateMedal;